import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

// components
import { CButton, CImage } from '@coreui/react-pro'
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// icons
import AddMoreIconWhite from '../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnGameList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'

const GameList = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [gameList, setGameList] = useState([]);
  const [gameListCount, setGameListCount] = useState(0);
  const [gameListPerPage, setGameListPerPage] = useState(10);
  const [activeGameListPage, setActiveGameListPage] = useState(1);
  const [searchGameListFilter, setSearchGameListFilter] = useState("");
  const [columnGameListSorter, setColumnGameListSorter] = useState({ column: "createdAt", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchGameListFilter,
      limit: gameListPerPage,
      offset: gameListPerPage * activeGameListPage - gameListPerPage,
      sort:
        (columnGameListSorter &&
          `${columnGameListSorter.column}-${columnGameListSorter.state}`) ||
        "",
    };
    queries = formUrlQuery(queries);
    fetchAllGames(queries);
  }, [
    searchGameListFilter,
    gameListPerPage,
    activeGameListPage,
    columnGameListSorter,
  ]);

  const handleSearchItems = (search) => {
    setActiveGameListPage(1)
    setSearchGameListFilter(search);
  }

  const fetchAllGames = (queries) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/gamepass/v1/game/list?${queries}`
    })
      .then(({ data }) => {
        const tempGameList = data?.value?.map((d) => ({
          ...d,
          is_active: d.is_active ? "Yes" : "No",
        }));

        setGameList(tempGameList);
        if (activeGameListPage === 1) {
          setGameListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  };

  const handleDeleteConfirmation = () => {
    Axios({
      method: "delete",
      url: `/api/gamepass/v1/game/delete/${showConfirmDelete?.item?.id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmDelete({ show: false, item: {} })
          fetchAllGames()
          window.location.reload()
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <>
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation 
            confirmationType='delete-item'
            itemName={showConfirmDelete?.item?.game_name}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
          />
        )
      }
      <div className='d-grid gap-2 d-md-flex justify-content-md-end mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/game/add')}>
          <CImage fluid src={AddMoreIconWhite} className='me-2' />
          Add Game
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Game List</h4>}
        bodyContent={
          <AppTable
            gameListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={columnGameList}
            tableContent={gameList}
            contentPerPage={gameListPerPage}
            activeContentPage={activeGameListPage}
            contentCount={gameListCount}
            searchContentFilter={searchGameListFilter}
            setActiveContentPage={setActiveGameListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setGameListPerPage}
            setColumnContentSorter={setColumnGameListSorter}
          />
        }
      />
    </>
  )
}

export default GameList